// Telugu
export const te = {
  'app.name':           'Kardolive',
  'app.tagline':        'కస్టమర్ పోర్టల్',
  'app.signOut':        'సైన్ అవుట్',

  'login.email':        'ఇమెయిల్',
  'login.password':     'పాస్‌వర్డ్',
  'login.signIn':       'సైన్ ఇన్',
  'login.signingIn':    'సైన్ ఇన్ అవుతోంది…',
  'login.failed':       'సైన్ ఇన్ విఫలమైంది',
  'login.newAccount':   'Kardoliveలో కొత్తవారా?',
  'login.createAccount':'ఉచిత ఖాతాను సృష్టించండి →',

  'nav.workspace':      'వర్క్‌స్పేస్',
  'nav.templates':      'టెంప్లేట్లు',
  'nav.live':           'లైవ్',
  'nav.rooms':          'గదులు & చాట్',
  'nav.content':        'కంటెంట్',
  'nav.developer':      'డెవలపర్',
  'nav.account':        'ఖాతా',

  'nav.overview':       'అవలోకనం',
  'nav.projects':       'ప్రాజెక్ట్‌లు',
  'nav.chat':           'చాట్ కన్సోల్',
  'nav.sessions':       'సెషన్‌లు',
  'nav.streams':        'ప్రత్యక్ష ప్రసారాలు',
  'nav.studio':         'స్టూడియో',
  'nav.recordings':     'రికార్డింగ్‌లు',
  'nav.apiKeys':        'API కీలు',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook టెస్టర్',
  'nav.networkTest':    'నెట్‌వర్క్ పరీక్ష',
  'nav.embed':          'ఎంబెడ్ విడ్జెట్‌లు',
  'nav.sdk':            'SDKలు మరియు పత్రాలు',
  'nav.docs':           'Developer docs',
  'nav.analytics':      'విశ్లేషణ',
  'nav.settings':       'సెట్టింగ్‌లు',

  'overview.welcome':       'తిరిగి స్వాగతం, {name}',
  'overview.plan':          '{tenant} · {plan} ప్లాన్',
  'overview.newStream':     'కొత్త ప్రసారం',
  'overview.kpi.live':           'ప్రస్తుతం ప్రత్యక్షం',
  'overview.kpi.live.broadcasting': 'ప్రసారాలు జరుగుతున్నాయి',
  'overview.kpi.live.nothing':    'ప్రత్యక్షంగా ఏమీ లేదు',
  'overview.kpi.total':           'మొత్తం ప్రసారాలు',
  'overview.kpi.total.sub':       'అన్ని కాలాలలో',
  'overview.kpi.sessions':        'సెషన్‌లు · 30 రోజులు',
  'overview.kpi.sessions.sub':    'ప్రచురణ ఈవెంట్‌లు',
  'overview.kpi.recordings':      'రికార్డింగ్‌లు',
  'overview.kpi.recordings.sub':  'ప్లే చేయడానికి సిద్ధం',
  'overview.recentStreams':       'ఇటీవలి ప్రసారాలు',
  'overview.recentSessions':      'ఇటీవలి సెషన్‌లు',
  'overview.viewAll':             'అన్నీ చూడండి →',
  'overview.empty.title':         'ఇంకా ప్రసారాలు లేవు',
  'overview.empty.body':          'ప్రసారం ప్రారంభించడానికి మీ మొదటి ప్రసారాన్ని సృష్టించండి.',
  'overview.empty.action':        'ప్రసారం సృష్టించండి',
  'overview.noSessions':          'ఇంకా సెషన్‌లు లేవు',

  'status.live':        'ప్రత్యక్షం',
  'status.idle':        'నిష్క్రియ',
  'status.ended':       'ముగిసింది',
  'status.archived':    'ఆర్కైవ్ చేసారు',

  'common.save':        'సేవ్',
  'common.cancel':      'రద్దు చేయండి',
  'common.delete':      'తొలగించండి',
  'common.edit':        'సవరించండి',
  'common.create':      'సృష్టించండి',
  'common.confirm':     'నిర్ధారించండి',
  'common.loading':     'లోడ్ అవుతోంది…',
  'common.error':       'లోపం',
  'common.retry':       'మళ్ళీ ప్రయత్నించండి',

  // Dashboard navigation and account controls.
  "nav.skipContent": "పేజీ కంటెంట్‌కు వెళ్లండి",
  "nav.streamTemplates": "స్ట్రీమ్ టెంప్లేట్లు",
  "nav.boards": "ఇంటరాక్టివ్ బోర్డులు",
  "nav.menu": "నావిగేషన్ తెరవండి",
  "nav.closeMenu": "నావిగేషన్ మూసివేయండి",
  "nav.scenarios": "వినియోగ సందర్భాలు",
  "nav.premieres": "ప్రీమియర్లు",
  "nav.clips": "క్లిప్‌లు",
  "dashboard.account": "ఖాతా",
  "dashboard.language": "భాష",
  "dashboard.appearance": "రూపం",
  "nav.allStreams": "అన్ని స్ట్రీమ్‌లు",
  "nav.destinations": "ప్రసార గమ్యస్థానాలు",
  "nav.ecommerce": "ఈ-కామర్స్",
  "nav.products": "ఉత్పత్తులు",
  "nav.services": "సేవలు",
  "nav.collections": "సేకరణలు",
  "nav.orders": "ఆర్డర్లు",
  "nav.commerceSettings": "వాణిజ్య సెట్టింగ్‌లు",
  "nav.engagement": "పాల్గొనడం",
  "theme.light": "లైట్ మోడ్‌కు మారండి",
  "theme.dark": "డార్క్ మోడ్‌కు మారండి",
  "role.owner": "యజమాని",
  "role.admin": "నిర్వాహకుడు",
  "role.member": "సభ్యుడు",
  "role.viewer": "వీక్షకుడు",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "సక్రియం",
  "streams.archived": "ఆర్కైవ్ చేసినవి",
  "streams.monitor": "మూలాల పర్యవేక్షణ",
  "streams.create": "లైవ్ స్ట్రీమ్ సృష్టించండి",
  "streams.list": "జాబితా",
  "streams.grid": "గ్రిడ్",
  "streams.view": "స్ట్రీమ్ వీక్షణ",
  "streams.searchLabel": "ఈవెంట్‌లను వెతకండి",
  "streams.searchHint": "ఈవెంట్ పేరుతో వెతకండి",
  "streams.solutionFilter": "రకం ఆధారంగా ఈవెంట్‌లను వడపోయండి",
  "streams.statusFilter": "స్థితి ఆధారంగా ఈవెంట్‌లను వడపోయండి",
  "streams.dateFilter": "సృష్టించిన తేదీ ఆధారంగా వడపోయండి",
  "streams.allSolutions": "అన్ని రకాలు",
  "streams.custom": "ప్రస్తుత లేదా అనుకూల సెటప్",
  "streams.allStatuses": "అన్ని స్థితులు",
  "streams.anyTime": "ఏ సృష్టి తేదీ అయినా",
  "streams.last7": "గత 7 రోజుల్లో సృష్టించినవి",
  "streams.last30": "గత 30 రోజుల్లో సృష్టించినవి",
  "streams.count": "{total} ఈవెంట్‌లలో {shown} చూపిస్తున్నాం",
  "streams.noMatch": "ఫిల్టర్‌లకు సరిపడే ఈవెంట్‌లు లేవు.",
  "streams.clearFilters": "ఫిల్టర్‌లు తొలగించండి",
  "streams.refreshFailed": "స్ట్రీమ్ జాబితాను రిఫ్రెష్ చేయలేకపోయాం",
  "streams.loadFailed": "స్ట్రీమ్‌లను లోడ్ చేయలేకపోయాం",
  "streams.stale": "చివరిగా లోడ్ చేసిన జాబితా చూపిస్తున్నాం. స్థితులు మారి ఉండవచ్చు.",
  "streams.connectionHint": "కనెక్షన్ తనిఖీ చేసి జాబితాను మళ్లీ లోడ్ చేయండి.",
  "streams.retrying": "మళ్లీ ప్రయత్నిస్తున్నాం…",
  "streams.retry": "మళ్లీ ప్రయత్నించండి",
  "streams.restoreFailed": "స్ట్రీమ్‌ను పునరుద్ధరించలేకపోయాం",
  "streams.restoreHint": "మళ్లీ ప్రయత్నించే ముందు కనెక్షన్ తనిఖీ చేసి తాజా స్థితి కోసం జాబితాను రిఫ్రెష్ చేయండి.",
  "streams.unused": "వాడని స్ట్రీమ్‌లు: {count}",
  "streams.unusedHint": "ప్రసారాలు లేదా రీప్లేలు లేవు. జాబితాను క్రమబద్ధం చేయడానికి ఆర్కైవ్ చేయండి; ఏదీ తొలగించబడదు.",
  "streams.reviewArchive": "సమీక్షించి ఆర్కైవ్ చేయండి",
  "streams.loading": "స్ట్రీమ్‌లను లోడ్ చేస్తున్నాం…",
  "streams.archiveEmpty": "ఆర్కైవ్ ఖాళీగా ఉంది. ఆర్కైవ్ చేసిన స్ట్రీమ్‌లు, రీప్లేలు పునరుద్ధరించే వరకు ఇక్కడ ఉంటాయి.",
  "streams.restore": "పునరుద్ధరించండి",
  "streams.firstTitle": "మీ మొదటి స్ట్రీమ్‌ను సృష్టించండి",
  "streams.firstBody": "అమ్మకాలు, తరగతి లేదా సేవ కోసం సెటప్ ఎంచుకోండి లేదా ఖాళీ స్ట్రీమ్‌తో ప్రారంభించండి. బ్రౌజర్, ఫోన్ లేదా OBS నుంచి ప్రసారం చేయండి.",
  "streams.blank": "ఖాళీ స్ట్రీమ్",
  "streams.broadcasts": "ప్రసారాలు: {count}",
  "streams.replays": "రీప్లేలు: {count}",
  "streams.sessions": "సెషన్‌లు: {count}",
  "streams.recordings": "రికార్డింగ్‌లు: {count}",
  "streams.mode.BROADCAST": "ప్రసారం",
  "streams.mode.LOW_LATENCY": "తక్కువ జాప్యం",
  "streams.mode.REALTIME": "రియల్ టైమ్",
  "streams.key": "కీ",
  "streams.archiveTitle": "వాడని స్ట్రీమ్‌లను ఆర్కైవ్ చేయండి",
  "streams.archiveHint": "ఈ స్ట్రీమ్‌లు ఎప్పుడూ ప్రసారం కాలేదు. ఆర్కైవ్ చేసినవి ట్యాబ్ నుంచి ఎప్పుడైనా పునరుద్ధరించవచ్చు.",
  "streams.archiveFailed": "{count} స్ట్రీమ్‌లను ఆర్కైవ్ చేయలేకపోయాం; అవి లైవ్‌లోకి వెళ్లి ఉండవచ్చు. మిగతావి ఆర్కైవ్ అయ్యాయి.",
  "streams.archiving": "ఆర్కైవ్ చేస్తున్నాం…",
  "streams.archiveCount": "{count} ఆర్కైవ్ చేయండి",
  "streamType.webinar": "వ్యాపార వెబినార్‌లు మరియు ప్రారంభాలు",
  "streamType.classroom": "తరగతులు మరియు ట్యూషన్",
  "streamType.training": "కార్పొరేట్ శిక్షణ",
  "streamType.conference": "సదస్సులు మరియు ప్రదర్శనలు",
  "streamType.shopping": "లైవ్ షాపింగ్",
  "streamType.auction": "లైవ్ వేలాలు",
  "streamType.consultation": "వ్యక్తిగత సంప్రదింపులు",
  "streamType.creator": "క్రియేటర్ మరియు కమ్యూనిటీ లైవ్",
  "streamType.audio": "ఆడియో గదులు మరియు పాడ్‌కాస్ట్‌లు",
  "streamType.sports": "క్రీడలు మరియు ఈ-స్పోర్ట్స్",
  "streamType.performance": "సంగీత కచేరీలు మరియు ప్రదర్శనలు",
  "streamType.community": "ఆరాధన మరియు నిధుల సేకరణ",
  "streamType.tour": "పర్యటనలు మరియు ప్రదర్శనలు",
  "streamType.fitness": "ఫిట్‌నెస్ మరియు వర్క్‌షాప్‌లు",
  "streamType.public-meeting": "వార్తలు మరియు బహిరంగ సమావేశాలు",
  "streamType.continuous": "నిరంతర ఛానల్‌లు మరియు కెమెరాలు",
  "streams.close": "మూసివేయండి",
};
